import { CommonModule } from '@angular/common';
import { Component, output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AiXpertService } from '@services';

@Component({
  selector: 'bo-simxpert',
  templateUrl: './simxpert.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule, FormsModule],
})
export class SimXpert {
  closeSimXpert = output();

  aiXpert = inject(AiXpertService);
}
